<template>
  <div class="content">
    <!-- <c-header
                    :left-arrow="false"/>
            <div class="login-in">
                <h1>登录</h1>
                <div class="img click-cursor" @click="goWxLogin">
                    <img src="../assets/images/weixin.jpg" alt="" style="width:100%;height:100%;">
                </div>
                <div class="login-main flex-column">
                    <span class="font-size-28">点击微信直接登录</span>
                </div>
                <div class="service-btn bg-primary font-size-28" @click="goRegister">没有账号，去注册</div>
            </div> -->
    <img v-if="data.scanWxCodeData!=null" class="scanImg" :src="data.scanWxCodeData.picurl" alt="">
  </div>
</template>

<script lang="ts">
  import {
    reactive,
    defineComponent,
    getCurrentInstance,
    onMounted,
    onBeforeMount
  } from 'vue';
  import {
    useRouter
  } from 'vue-router';
  import common from '@/assets/ts/common';
  import {Toast} from 'vant';
  interface HomeConfig {
    scanWxCodeData: any[],
  }
  export default defineComponent({
    setup() {
      onMounted(() => {
        getBanner();
      });
      const router = useRouter();
      const data = reactive < HomeConfig > ({
        scanWxCodeData: [],
      });
      const {
        ctx
      }: any = getCurrentInstance();
      const getBanner = (): void => {
        // 经销商  /adproduct/getBannerTopList
        // 客户    /adproduct/getBannerTopListCustom
        common.request("get", "/adproduct/getBannerTopListCustom")
        // common.request("get", "/adproduct/getBannerTopList")
          .then((res: any) => {
            data.scanWxCodeData = res.data;
            console.log(data.scanWxCodeData)
            if(data.scanWxCodeData == null){
              Toast.fail('数据丢失，正在返回上一页');
              setTimeout(() => {
                router.go(-1);
              }, 2000);
              
            }
          })
      };
      // const goRegister = () => {
      //   router.push('/register');
      // };
      // const goWxLogin = () => {
      //   location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxffd7309385d2fc24&redirect_uri=https://zcq.jnddsoft.cn&response_type=code&connect_redirect=1&scope=snsapi_userinfo&state=STATE#wechat_redirect';
      // };
      return {
        data,
        // goRegister,
        // goWxLogin
      };
    }
  });
</script>

<style scoped lang="scss">
  @import '../assets/scss/common.scss';
  .content {
    height: 100vh;
  }
  .scanImg{
    width: 100%;
    height: 100%;
  }
  .noImg{
    margin: 200px auto;
  }
  .img {
    width: 168px;
    height: 168px;
    margin: 0 auto 30px auto;
  }
  .login-in {
    margin-top: 88px;
    padding: 74px;
    h1 {
      font-size: 60px;
      margin-bottom: 80px;
    }
    .login-main {
      align-items: center;
      a {
        margin-bottom: 50px;
        width: 168px;
        height: 168px;
        display: block;
      }
      span {
        margin-bottom: 80px;
      }
      .login-btn {
        width: 100%;
        background: $primary-color;
        color: #fff;
        font-size: 36px;
        border-radius: 10px;
        height: 90px;
        line-height: 90px;
        text-align: center;
      }
    }
  }
  .service-btn {
    top: 65vh;
    width: 260px;
  }
</style>
